import type { IngestionChainState } from '@/types'

interface IngestionChainStatus {
  chainState: IngestionChainState | null
  chainDisplayName: string | null
  chainStartsSuspended: boolean
}

export function describeIngestionChainProblem({ chainState, chainDisplayName, chainStartsSuspended }: IngestionChainStatus): string | null {
  if (chainState === null) return null

  const named = chainDisplayName ? ` "${chainDisplayName}"` : ''

  if (chainState === 'Missing')
    return 'The chain selected to start on ingestion was deleted, so no chain runs are started. Select another chain or None and save the ingestion settings.'

  if (chainState === 'Inactive')
    return `The chain${named} selected to start on ingestion is inactive, so no chain runs are started. Select an active chain or None and save the ingestion settings.`

  if (chainStartsSuspended)
    return `Chain runs are paused because the chain${named} was deactivated or deleted. Save the ingestion settings to start them again.`

  return null
}
